import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from '@/services/TranslationService';
import { NovovilleButton, Typography } from '@/components/novoville';
import ReCAPTCHAInput from '../auth/components/ReCAPTCHAInput';
import ActiveSelectedApplication from '../applications/ActiveSelectedApplication/ActiveSelectedApplication';
import { withNOVOHeader } from '../sideMenu/HeaderHOC';

const RouteFormApplication = ({ history, setHeaderTitle }) => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [activeApplication, setActiveApplication] = useState(null);

  const deeplinkMeta = useSelector((state) => state.deeplinkReducer?.meta);
  const publicApplicationType = deeplinkMeta?.public_application_type || null;
  const publicApplicationTypeFound =
    deeplinkMeta?.public_application_type_found === true;

  useEffect(() => {
    setHeaderTitle?.(translate('sideMenu.Applications'));
  }, [setHeaderTitle]);

  const goHome = useCallback(() => {
    history.push('/');
  }, [history]);

  const continueToApplication = useCallback(() => {
    if (!recaptchaToken || !publicApplicationType) return;

    setActiveApplication({
      ...publicApplicationType,
      recaptchaToken,
    });
  }, [publicApplicationType, recaptchaToken]);

  if (activeApplication) {
    return (
      <ActiveSelectedApplication
        activeApplication={activeApplication}
        onResetActiveApplication={() => setActiveApplication(null)}
        onApplicationSubmitted={goHome}
      />
    );
  }

  if (!publicApplicationTypeFound) {
    return (
      <div className="relative flex flex-1 flex-col">
        <div className="m-auto flex w-full max-w-md flex-col items-center gap-6 px-6 text-center">
          <Typography variant="bold_24">
            {translate('defaultErrorTitle')}
          </Typography>
          <Typography variant="regular_16">
            {translate('publicFormApplication.notFoundTitle')}
          </Typography>
          <NovovilleButton
            variant="primary"
            text={translate('Home')}
            onClick={goHome}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="relative flex flex-1 flex-col">
      <div className="m-auto flex w-full max-w-md flex-col items-center gap-6 px-6 text-center">
        <div className="flex flex-col gap-2">
          <Typography variant="bold_24">
            {publicApplicationType.title || publicApplicationType.name}
          </Typography>
          <Typography variant="regular_16">
            {translate('verify')}
          </Typography>
        </div>

        <ReCAPTCHAInput onVerify={setRecaptchaToken} />

        <NovovilleButton
          variant="primary"
          text={translate('continue')}
          disabled={!recaptchaToken}
          onClick={continueToApplication}
        />
      </div>
    </div>
  );
};

export default withNOVOHeader(withRouter(RouteFormApplication));
